import { routesPath } from './routesPath';
export const wizardViews = {
  client: (id) => [
    {
      step: 0,
      id: id,
      label: !id ? 'Create Client Profile' : 'Edit Client Profile',
      routesPath: !id ? routesPath.clientFormPage : routesPath.editClient(id),
    },
    {
      step: 1,
      id: id,
      label: 'Add primary contacts',
      routesPath: routesPath.addContacts(id),
    },
    {
      step: 2,
      id: id,
      label: !id ? 'Add Projects' : 'Add / Remove Projects',
      routesPath: routesPath.addProjects(id),
    },
  ],
};
